<ng-container *ngFor="let button of getButtonList()">
  <div
    [hidden]="!isVisible(button)"
    class="button-list"
    (click)="click(button)"
    [ngClass]="{ disabled: isDisabled(button) }"
    [soti-tooltip]="button.toolTipName()"
    placement="left"
  >
    <span
      class="hd-icon {{ button.icon }} icon-lg device-icon {{ button.cssClass ? button.cssClass : '' }}"
      [ngClass]="{ spinning: isSpinning(button) }"
    >
      <mat-spinner class="button-spinner" [diameter]="30" [strokeWidth]="2" *ngIf="isSpinning(button)"></mat-spinner>
    </span>
  </div>
</ng-container>
